import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useAuthStore } from 'src/store/auth'
import { rootMenuLink } from 'src/store/auth/menu'

export const AuthRoute = () => {
  const user = useAuthStore((store) => store.user)

  const userData = user || JSON.parse(window.localStorage.getItem('user'))

  const rootRedirect = rootMenuLink(userData?.role)

  return userData ? <Navigate to={rootRedirect} /> : <Outlet />
}
